import { render, staticRenderFns } from "./DataContainer.vue?vue&type=template&id=58beaadc&scoped=true&"
var script = {}
import style0 from "./DataContainer.vue?vue&type=style&index=0&id=58beaadc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58beaadc",
  null
  
)

export default component.exports